import { Button, Stack, Table, Tbody, Td, Text, Tr } from '@chakra-ui/react'
import { faUserMinus } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { type ReactElement } from 'react'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

import { getUserUrl } from '@/client/services/url'

import ShwLink from '@/components/ShwLink'
import UserAvatar from '@/components/UserAvatar'

import type { HostToastInfo } from './CohostReviewModal/types'
import type { HostAvatarDetails } from './types'

export default function HostTable({
  hosts,
  canRemoveHosts,
  setRemoveCohostInfo,
  setShowTableModal,
}: {
  hosts: HostAvatarDetails[]
  canRemoveHosts: boolean
  setRemoveCohostInfo: (cohostInfo: HostToastInfo | null) => void
  setShowTableModal: (showModal: boolean) => void
}): ReactElement {
  return (
    <Table variant="ghost" width="100%">
      <Tbody>
        {hosts.map(host => (
          <React.Fragment key={host.hostId ?? 0}>
            <Tr>
              <Td pl={-4} flex={1}>
                <ShwLink
                  href={getUserUrl({ userId: host.userId ?? 0, username: host.username })}
                  width="100%"
                >
                  <Stack
                    direction="row"
                    width="100%"
                    p="8px"
                    spacing={4}
                    align="center"
                    borderRadius="8px"
                    _hover={{ backgroundColor: 'bg.muted' }}
                    cursor="pointer"
                  >
                    <UserAvatar
                      src={`${host.avatarSrc}`}
                      name={`${host.avatarName}`}
                      size="md"
                      progressionLevel={host.progressionLevel}
                    />
                    <Text fontWeight="bold">
                      {`${host.avatarName}`}{' '}
                      {host.role === 'main' ? ' (Primary Host)' : ' (Co-host)'}
                    </Text>
                  </Stack>
                </ShwLink>
              </Td>
              {!canRemoveHosts ? null : host.role !== 'main' ? (
                <Td>
                  <Button
                    variant="outline"
                    textColor="fg.error"
                    borderColor="border.emphasized"
                    leftIcon={
                      <FontAwesomeIcon color={chakraTokenToVar('fg.error')} icon={faUserMinus} />
                    }
                    onClick={() => {
                      setRemoveCohostInfo({ hostId: host.hostId, name: host.avatarName })
                      setShowTableModal(false)
                    }}
                  >
                    Remove Co-host
                  </Button>
                </Td>
              ) : (
                <Td />
              )}
            </Tr>
          </React.Fragment>
        ))}
      </Tbody>
    </Table>
  )
}
